
import { AppBehavior } from '../lib/core/AppBehavior';
import { GPS } from '../lib/core/GPS';
import { Component, Vue } from 'vue-property-decorator';
import { container } from '../lib/container';

const gps = container.get<GPS>('gps');
const behavior = container.get<AppBehavior>('behavior');

@Component({})
export default class LocalizeBtn extends Vue {
	behavior!: AppBehavior;

	created() {
		this.behavior = behavior;
	}

	onClick() {
		gps.localize();
	}
}
